import _ from 'lodash-es';
import handleize from '../../../core/INF-handleize';
import carouselHTML from './carouselHTML';

export default (product_json, variant_image_map, $carousels_data, $container) => {
  const processed_option1s = [];

  _.every(product_json.variants, (variant) => {
    if (processed_option1s.indexOf(variant.option1) >= 0 || !variant.featured_image) {
      return true;
    }

    processed_option1s.push(variant.option1);

    const carousel_images = [];
    const src = variant.featured_image.src;
    const src_without_query = src.split('https:')[1].split('?')[0];
    let found_variant = false;

    _.every(product_json.images, (image) => {
      const image_without_query = image.split('?')[0];

      if (found_variant && !_.find(variant_image_map[image_without_query], { option1: variant.option1 }) && variant_image_map[image_without_query].length > 0) {
        // We've hit a new variant, stop
        return false;
      }

      if (!found_variant && image_without_query === src_without_query) {
        found_variant = true;
      }

      if (found_variant) {
        carousel_images.push({ 
          src: image,
          variants: variant_image_map[image_without_query],
        });
      }

      return true;
    });

    const extras = {
      data: `data-option1="${variant.option1}"`,
    };
    const carousel_html = carouselHTML($carousels_data, carousel_images, `OptionCarousel-${handleize(variant.option1)}`, extras);
    $('[data-product-images-carousels]', $container).append(carousel_html);

    return true;
  });

  $(document).trigger('productOverviewCarouselsDidPopulate', 'option1');
};